import { api } from "./client";

export type JarvisRef = { type: "contact" | "campaign" | "pipeline"; id: string };

export type JarvisDelivery = "session" | "slack_only" | "failed";

export interface JarvisMessageResponse {
  delivery: JarvisDelivery;
  session_id?: string;
  channel_id?: string;
}

export const jarvisApi = {
  message: (text: string, ref?: JarvisRef) =>
    api.post<JarvisMessageResponse>("/api/v1/jarvis/messages", { text, ref }),
};
